module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./zh-WUU-HANT.coffee"));
	}, "locale/zh-WUU-HANT");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/zh-WUU-HANT.coffee
// module id = 311
// module chunks = 97